var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table-column',{attrs:{"label":_vm.renderLabel,"field":_vm.sort,"sortable":_vm.sort.length > 2,"visible":_vm.renderVisibleValue}},[_vm._t("default",function(){return [_vm._v("🚫 "+_vm._s(_vm.$t('Content missing'))+" 🚫")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }